import I18n from 'I18n';
import formatShortDate from 'I18n/utils/formatShortDate';

// formats a timestamp as "Jan 20" (locale-aware) if from current year
// or "Jan 20, 2020" (locale-aware) if from different year

export function formatDateRelativeToCurrentYear(timestamp) {
  const date = I18n.moment.userTz(timestamp);
  const currentYear = I18n.moment.userTz().year();
  if (date.year() === currentYear) {
    return formatShortDate(timestamp, 'userTz');
  }
  return date.format('ll');
}